import {
  LANGUAGE_INIT,
  LANGUAGE_INIT_FAILURE,
  LANGUAGE_INIT_SUCCESS,
  LANGUAGE_UPDATE,
} from './types';

export function initLanguage() {
  return {
    type: LANGUAGE_INIT,
  };
}

export function initLanguageSuccess(localeId) {
  return {
    type: LANGUAGE_INIT_SUCCESS,
    payload: {
      localeId,
    },
  };
}

export function initLanguageFailure(error) {
  return {
    type: LANGUAGE_INIT_FAILURE,
    error: true,
    payload: error,
  };
}

export function updateLanguage(localeId) {
  return {
    type: LANGUAGE_UPDATE,
    payload: {
      localeId,
    },
  };
}
